export const globalInitialState = {
  data: null,
  error: null,
  loading: false,
};
